import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";
import {FRUtilities} from "#Formulas/FormulaCore/Utilities/FRUtilities";


export class FRMembE extends FRBase{
    private Subt:string;
    private Prop:FRBase;
    private Caller:FRBase;
    public Args:FRBase[];
    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);
        this.Subt=this.Options.St;
        if(this.Options.St=='Pr')
            this.Prop=this.Options.Pr;
        else
            this.Prop=FRFactory.GetFRElement(this.Options.Pr,this);
        this.Caller=FRFactory.GetFRElement(this.Options.C,this);

        this.Args=[];
        if(Array.isArray(this.Options.Args))
            this.Options.Args.forEach(x=>this.Args.push(FRFactory.GetFRElement(x,this)));
    }

    Parse(): any {
        return this.MaybeExecutePromise(this.Caller.Parse(),caller=>{
            switch (this.Subt)
            {
                case 'Pr':
                    let property=String(this.Prop);

                    if(caller[property]==null)
                        return null;

                    if(!(property in caller))
                        return null;

                    if(typeof caller[property]=='function') {
                        let args=[];
                        return this.Iterate(this.Args, item =>args.push(item),()=>(caller[property] as Function).apply(caller, args));
                    }

                    else
                        return caller[property];


                case 'Arr':
                    return this.MaybeExecutePromise(this.Prop.Parse(),index=>{
                        if(index==null)
                            return null;
                        if(!Array.isArray(caller)||caller[index]==undefined)
                            return null;
                        return caller[index];
                    });


            }
        })


    }

    Assign(value: any) {
        return this.MaybeExecutePromise(this.Caller.Parse(),caller=>{
            switch (this.Subt)
            {
                case 'Arr':
                    let prop=this.Prop.Parse();
                    let index=FRUtilities.SanitizeNumber(prop,null);
                    if(index==null)
                        return null;
                    if(!Array.isArray(caller)||caller.length<index)
                        return null;
                    caller[index]=value;
                    break;
                case 'Pr':
                    if(this.Args.length>0)
                        return;

                    let property=String(this.Prop);

                    if(!(property in caller))
                        return null;

                    if(typeof caller[property]!='function')
                        return caller[property]=value;

                    return;

            }
        });

    }
}

FRFactory.AddField('ME',FRMembE);